export default __webpack_public_path__ + "static/media/foodlens.ee4eea18.png";